import React from 'react';

interface DisclaimerProps {
  children: React.ReactNode;
}

const Disclaimer: React.FC<DisclaimerProps> = ({ children }) => (
  <div className="gv-disclaimer" role="note">
    {children}
  </div>
);

export default Disclaimer;
